import { formatScheduleCompact } from "./scheduleDisplay";
import { formatCurrency } from "./currency";

/**
 * Format offering price for schedule lines using stored amount + currency
 * with Intl when possible (source amount on the offering, not multi-stored FX).
 */
export function formatOfferingPriceLabel(offering) {
  if (!offering || offering.price == null || offering.price === "") return "";
  const amount = Number(offering.price);
  const currency = String(offering.currency || "INR").toUpperCase();
  if (!Number.isFinite(amount) || amount <= 0) {
    const raw = String(offering.price).trim();
    if (!raw) return "";
    return `${currency} ${raw}`;
  }
  return formatCurrency(amount, currency) || `${currency} ${amount}`;
}

/**
 * Build structured class-schedule rows + always-on on-request option.
 * Each fixed row: { title, when, price, variant }
 * Request row: { title: "", when: "Price & schedule on request", variant: "request" }
 */
export function buildTeacherScheduleLines(offerings, { includePrices = true } = {}) {
  const items = Array.isArray(offerings) ? offerings : [];
  const fixed = items
    .map((offering) => {
      const when = formatScheduleCompact(offering.schedule_json, offering.schedule_summary);
      if (!when) return null;
      return {
        title: offering.title || "",
        when,
        // Keep legacy `schedule` for simple consumers / YogaCard
        schedule: [when, includePrices ? formatOfferingPriceLabel(offering) : ""]
          .filter(Boolean)
          .join(" · "),
        price: includePrices ? formatOfferingPriceLabel(offering) : "",
        variant: "class",
      };
    })
    .filter(Boolean);

  return [
    ...fixed,
    {
      title: "",
      when: "Price & schedule on request",
      schedule: "Price & schedule on request",
      price: "",
      variant: "request",
    },
  ];
}
